export function formatSeconds(sec: number, daysLocale: string, isRtl: boolean) {
  let days, hours, minutes, seconds = Math.floor(sec) as any;
  [days, seconds] = [Math.floor(seconds / 86400), seconds % 86400];
  [hours, seconds] = [Math.floor(seconds / 3600), seconds % 3600];
  [minutes, seconds] = [Math.floor(seconds / 60), seconds % 60];

  [hours, minutes, seconds] = [hours, minutes, seconds].map(x => `00${x}`.slice(-2));

  return days
    ? !isRtl ? `${days}${daysLocale}, ${hours}:${minutes}` : `${hours}:${minutes} ,${days} ${daysLocale}`
    : `${hours}:${minutes}:${seconds}`;
}

export function toProperDate(date: any, direction = 'ltr', separator = '-'){
  return direction === 'ltr' ?
  `${(date.getFullYear()+'').padStart(4, '0')}${separator}${(date.getMonth()+1+'').padStart(2, '0')}${separator}${(date.getDate()+'').padStart(2, '0')}` :
  `${(date.getDate()+'').padStart(2, '0')}${separator}${(date.getMonth()+1+'').padStart(2, '0')}${separator}${(date.getFullYear()+'').padStart(4, '0')}`
}

export function toDate(date) { return new Date(fixTime(date)) }

export function toTime(hour,minute) { return `${hour}`.padStart(2,'0')+`:`+ `${minute}`.padStart(2,'0')}

export function timeLanguageFormat(language, time: string) {
  return (new Intl.DateTimeFormat(language, { hour: 'numeric', minute: 'numeric' }).format(new Date(time)))
}

export function dateLanguageFormat(language, date: string) {
  return (new Intl.DateTimeFormat(language).format(new Date(fixTime(date))))
}

export function getIsoDate(value){
  const date = new Date(value);
  const year = `${date.getFullYear()}`.padStart(4, '0');
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}

//TODO [R.C] fix new Date issue that returns different day dependent on timezone
export function fixTime(date) {
  return date + 'T00:00:00'
}